import adminApi from "./api/adminApi";
import authApi from "./api/authApi";
import dashboardApi from "./api/dashboardApi";
import digitalDashboardApi from "./api/digitalDashboard";
import ActivityTrackerApi from "./api/ActivityTrackerApi";
import notificationApi from "./api/notificationApi";
import leadDashboardApi from "./api/leadDashboardApi";
import orderManagementApi from "./api/orderManagementApi";
import featureApi from "./api/featureApi";
import hoFilterApi from "./api/hoFilterApi";

const apiService = {
  ...dashboardApi,
  ...adminApi,
  ...authApi,
  ...digitalDashboardApi,
  ...ActivityTrackerApi,
  ...notificationApi,
  ...leadDashboardApi,
  ...orderManagementApi,
  ...featureApi,
  ...hoFilterApi,
};

export default apiService;